import wixLocation from 'wix-location';

$w.onReady(function () {

	wixLocation.to("https://5am-games.online");

});